import { render, staticRenderFns } from "./grades.vue?vue&type=template&id=0f75622e&"
import script from "./grades.vue?vue&type=script&lang=js&"
export * from "./grades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports